import React from 'react';
import moment from 'moment';
import userStore from '../../../../../store/userStore';
import { getStatusStyle } from '../../../utils/expedientsListUtils';
import { CurrencyFormatComponent } from '../../../../../utils/currencyUtils';
import { EXPEDIENT_TYPES, EXPEDIENT_TYPE_LABELS, expedientStatusLabel } from '@claimup/shared/constants/expedient';
import { isGroupUser } from '../../../../../utils/userScope';

const ExpedientRow = ({ createdAt, expedient, role, showPhase = false, bulkMode = false, selectable = false, selected = false, onToggle }) => {
  const { user_id, deudores_id, importe_deuda, estado, type, _id, divisa, operator_ids, debt_activity } = expedient;
  const { user } = userStore();

  const formattedDate = createdAt ? moment(createdAt).format('DD/MM/YYYY') : 'No Date';

  const firstDebtActivityDate = debt_activity?.[0]?.date;
  const daysSinceFirstDebtActivity = firstDebtActivityDate
    ? moment().diff(moment(firstDebtActivityDate), 'days')
    : null;

  return (
    <tr className='hover:bg-gray-50 transition-colors duration-150'>
      {bulkMode && (
        <td className='px-4 py-3 whitespace-nowrap'>
          {selectable && (
            <input
              type='checkbox'
              aria-label={`Marcar ${deudores_id?.[0]?.debtorname || 'expediente'}`}
              checked={selected}
              onChange={onToggle}
            />
          )}
        </td>
      )}
      {showPhase && (
        <td className='px-4 py-3 whitespace-nowrap'>
          <span className='px-2.5 py-0.5 inline-flex text-xs leading-5 font-semibold rounded-full bg-slate-100 text-slate-700'>
            {/* Sin `type` es un expediente de antes de la fase: recobro. */}
            {EXPEDIENT_TYPE_LABELS[type || EXPEDIENT_TYPES.EXTRA_JUDICIAL]}
          </span>
        </td>
      )}
      <td className='px-4 py-3 whitespace-nowrap'>
        <div className='text-sm text-gray-800'>{formattedDate}</div>
      </td>
      {(user?.role === 'admin' || isGroupUser(user)) && (
        <td className='px-4 py-3 whitespace-nowrap'>
          <div className='text-sm text-gray-800'>
            {user_id?.username
              ? `${user_id.username}${user_id.userlastname?.[0] ? ` ${user_id.userlastname[0]}.` : ''}`
              : user_id?.usermail || (
                  <span className='text-red-500' role='img' aria-label='no data'>
                    <svg className='w-4 h-4' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
                      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
                    </svg>
                  </span>
                )}
          </div>
        </td>
      )}
      {(user?.role === 'admin' || (user?.role === 'company' && !user?.operators_handle_all)) && (
        <td className='px-4 py-3 whitespace-nowrap'>
          {/* Todos los que lo llevan, no solo el primero: con el reparto en bloque
              un expediente puede tener varios. Si la empresa deja que todo su
              equipo lo vea todo, `operator_ids` no se mira: lo lleva el equipo. */}
          <div className='text-sm text-gray-800'>
            {user_id?.operators_handle_all ? (
              'Todo el equipo'
            ) : operator_ids?.some(o => o && typeof o === 'object') ? (
              operator_ids
                .filter(o => o && typeof o === 'object')
                .map(o => (o.username ? `${o.username}${o.userlastname?.[0] ? ` ${o.userlastname[0]}.` : ''}` : o.usermail || '—'))
                .join(', ')
            ) : (
              <span className='text-amber-700'>Sin asignar</span>
            )}
          </div>
        </td>
      )}
      <td className='px-4 py-3 whitespace-nowrap'>
        <div className='text-sm font-medium text-gray-800'>{deudores_id[0].debtorname}</div>
      </td>
      <td className='px-4 py-3 whitespace-nowrap'>
        <div className='text-sm font-medium text-gray-800'>
          <CurrencyFormatComponent value={importe_deuda} divisa={divisa} />
        </div>
      </td>
      <td className='px-4 py-3 whitespace-nowrap'>
        <span
          className={`px-2.5 py-0.5 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusStyle(estado)}`}
        >
          {expedientStatusLabel(estado)}
        </span>
      </td>
      <td className='px-4 py-3 whitespace-nowrap'>
        <div className='text-sm text-gray-800'>
          {daysSinceFirstDebtActivity !== null ? `${daysSinceFirstDebtActivity} días` : 'N/A'}
        </div>
      </td>
      <td className='px-4 py-3 whitespace-nowrap'>
        <div className='flex items-center'>
          <a
            href={`/view/${_id}`}
            target='_blank'
            rel='noreferrer'
            className='text-blue-600 hover:text-blue-800 transition-colors duration-150'
          >
            <svg className='w-5 h-5' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 12a3 3 0 11-6 0 3 3 0 016 0z' />
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'
              />
            </svg>
          </a>
        </div>
      </td>
    </tr>
  );
};

export default ExpedientRow;
